<template>
    <div
    class=""
    >
        <v-toolbar class="primary darken">
        <v-toolbar-title class="white--text">This Month</v-toolbar-title>
        </v-toolbar>
        <v-container grid-list-md>
            <v-layout row wrap>
                <v-flex sm12 md6>
                    <v-container v-if="birthdaysThisMonth === null">
                      <v-progress-circular color="primary" indeterminate>
                      </v-progress-circular>
                    </v-container>
                    <v-card class=" " v-else>
                        <v-card-title class="primary darken white--text">
                        Birthdays
                        </v-card-title>
                        <v-data-table
                        light
                        :headers="headersBirthday"
                        :items="birthdaysThisMonth"
                        hide-default-footer
                        >
                        <template slot="items" slot-scope="props">
                        <tr>
                            <td>{{ props.item.name }}</td>
                            <td>{{ props.item.birthDate }}</td>
                        </tr>
                        </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
                <v-flex sm12 md6>
                    <v-container v-if="anniversariesThisMonth === null">
                      <v-progress-circular color="primary" indeterminate>
                      </v-progress-circular>
                    </v-container>
                    <v-card class="" v-else>
                        <v-card-title class="tile-contacts primary darken white--text">
                        Anniversaries
                        </v-card-title>

                        <v-data-table
                        light
                        :headers="headersAnniversaries"
                        :items="anniversariesThisMonth"
                        hide-default-footer
                        >
                        <template slot="items" slot-scope="props">
                        <tr>
                            <td>{{ props.item.name }}</td>
                            <td>{{ props.item.years }}</td>
                        </tr>
                        </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
export default {
  data() {
    return {
      headersBirthday: [
        {
          text: "Name",
          align: "center",
          sortable: true,
          value: "name"
        },
        {
          text: "Birthday",
          align: "center",
          value: "birthDate"
        }
      ],
      headersAnniversaries: [
        {
          text: "Name",
          align: "center",
          sortable: true,
          value: "name"
        },
        {
          text: "Years",
          align: "center",
          value: "years"
        }
      ]
    };
  },
  computed: {
    birthdaysThisMonth(){
      let birthdays = this.$store.getters.birthdaysThisMonth;
      if(birthdays === null) return null;
      return Object.values(birthdays);
    },
    anniversariesThisMonth(){
      let anniversaries = this.$store.getters.anniversariesThisMonth;
      if(anniversaries === null) return null;
      return Object.values(anniversaries);
      let date = new Date();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/People/ThisMonth.vue